"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeDelta = exports.parseResolution = exports.getViewportAndScreen = exports.getChromeVersion = exports.printCodecs = exports.printTrack = exports.filterUndefined = exports.PeriodicOperation = exports.ListenerCounter = exports.timeout = exports.sleep = exports.MBToBytes = exports.bytesToMB = exports.hoursInMs = exports.sum = void 0;
var pickBy_1 = __importDefault(require("lodash/pickBy"));
function sum(arr) {
    return arr.reduce(function (res, value) { return res + value; }, 0);
}
exports.sum = sum;
exports.hoursInMs = function (count) { return count * 60 * 60 * 1000; };
exports.bytesToMB = function (bytes) { return bytes / (1024 * 1024); };
exports.MBToBytes = function (mb) { return mb * 1024 * 1024; };
function sleep(timeInMs) {
    return new Promise(function (resolve) {
        setTimeout(resolve, timeInMs);
    });
}
exports.sleep = sleep;
function timeout(actionPromise, timeoutInMs, description) {
    var timeoutRef;
    var timeoutPromise = new Promise(function (resolve, reject) {
        timeoutRef = window.setTimeout(function () { return reject(new Error(description + " timeout after " + timeoutInMs + " ms")); }, timeoutInMs);
    });
    // Clear timeout when promise finalizes (rejected or resolved)
    return Promise.race([actionPromise.finally(function () { return clearTimeout(timeoutRef); }), timeoutPromise]);
}
exports.timeout = timeout;
var ListenerCounter = /** @class */ (function () {
    function ListenerCounter() {
        this.listenersMap = new Map();
    }
    ListenerCounter.prototype.add = function (type, listener) {
        var list = this.listenersMap.get(type) || [];
        this.listenersMap.set(type, list.concat(listener));
    };
    ListenerCounter.prototype.remove = function (type, listener) {
        var list = this.listenersMap.get(type) || [];
        if (list.length) {
            this.listenersMap.set(type, list.filter(function (l) { return l !== listener; }));
        }
    };
    ListenerCounter.prototype.removeAll = function (type) {
        this.listenersMap.delete(type);
    };
    ListenerCounter.prototype.get = function (type) {
        return this.listenersMap.get(type) || [];
    };
    ListenerCounter.prototype.getAll = function () {
        return Array.from(this.listenersMap);
    };
    return ListenerCounter;
}());
exports.ListenerCounter = ListenerCounter;
var PeriodicOperation = /** @class */ (function () {
    function PeriodicOperation(op, timeoutInMs) {
        this.op = op;
        this.timeoutInMs = timeoutInMs;
    }
    PeriodicOperation.prototype._start = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.handle = window.setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: 
                            // Block until operation is complete to avoid race conditions
                            return [4 /*yield*/, this.op()];
                            case 1:
                                // Block until operation is complete to avoid race conditions
                                _a.sent(); // Operation should catch errors itself
                                this._start();
                                return [2 /*return*/];
                        }
                    });
                }); }, this.timeoutInMs);
                return [2 /*return*/];
            });
        });
    };
    PeriodicOperation.prototype.start = function (runInitially) {
        if (runInitially === void 0) { runInitially = true; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!runInitially) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.op()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, this._start()];
                }
            });
        });
    };
    PeriodicOperation.prototype.stop = function () {
        window.clearTimeout(this.handle);
    };
    return PeriodicOperation;
}());
exports.PeriodicOperation = PeriodicOperation;
function filterUndefined(input) {
    return pickBy_1.default(input, function (value) { return value !== undefined; });
}
exports.filterUndefined = filterUndefined;
function printTrack(track) {
    var width = track.width, height = track.height, frameRate = track.frameRate;
    return width + "x" + height + "@" + (frameRate || 'N/A');
}
exports.printTrack = printTrack;
function printCodecs(track) {
    var audioCodec = track.audioCodec, videoCodec = track.videoCodec;
    return videoCodec + " / " + (audioCodec || 'N/A');
}
exports.printCodecs = printCodecs;
function getChromeVersion() {
    var match = navigator.userAgent.match(/.*Chrome\/([0-9\.]+)/);
    return match ? match[1] : 'N/A';
}
exports.getChromeVersion = getChromeVersion;
function getViewportAndScreen() {
    var width = screen.width, height = screen.height;
    return innerWidth + "x" + innerHeight + " / " + width + "x" + height + "*" + devicePixelRatio;
}
exports.getViewportAndScreen = getViewportAndScreen;
function parseResolution(input) {
    if (!input)
        return null;
    input = input.trim().toLocaleLowerCase();
    if (input === 'uhd' || input === 'ultrahd' || input === '4k') {
        return {
            width: 3840,
            height: 2160
        };
    }
    else if (input === 'fullhd') {
        return {
            width: 1920,
            height: 1080
        };
    }
    else if (input === 'hdready') {
        return {
            width: 1280,
            height: 720
        };
    }
    var simpleResFormatMatch = input.match(/^(\d+)p$/); // ex: 2160p
    if (simpleResFormatMatch) {
        var height = Number(simpleResFormatMatch[1]);
        return {
            width: Math.floor(height * 16 / 9),
            height: height
        };
    }
    var fullResFormatMatch = input.match(/^(\d+)(?:x(\d+))?$/); // ex: 3840x2160 or 3840
    if (fullResFormatMatch) {
        var width = Number(fullResFormatMatch[1]);
        return {
            width: width,
            height: fullResFormatMatch[2] ? Number(fullResFormatMatch[2]) : undefined
        };
    }
    return null;
}
exports.parseResolution = parseResolution;
function timeDelta(startTs, endTs) {
    endTs = endTs || Date.now();
    return (endTs - startTs) / 1000;
}
exports.timeDelta = timeDelta;
